export default __webpack_public_path__ + "static/media/Ahmed.500cfb22.png";